"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiveRemoteConfig = exports.RemoteConfig = void 0;
var utils_1 = require("./utils");
var RemoteConfig = /** @class */ (function () {
    function RemoteConfig(values) {
        this.params = values;
    }
    RemoteConfig.prototype.GetValueOrDefault = function (key, defaultValue) {
        return this.params[key] ? this.params[key] : defaultValue;
    };
    return RemoteConfig;
}());
exports.RemoteConfig = RemoteConfig;
var DiveRemoteConfig = /** @class */ (function () {
    function DiveRemoteConfig() {
        this.config = null;
        this.loaded = false;
    }
    DiveRemoteConfig.prototype.GetRemoteConfig = function (json) {
        if (json === null && this.config !== null)
            return this.config;
        if (json === null) {
            json = utils_1.default.getRemoteConfig();
            if (json === null)
                return null;
        }
        else {
            this.loaded = true;
        }
        this.config = {
            configVersion: json['config_version'],
            metadataExperiments: json['metadata_experiments'],
            remoteConfig: new RemoteConfig(json['remote_config'])
        };
        utils_1.default.setRemoteConfig(json);
        return this.config;
    };
    return DiveRemoteConfig;
}());
exports.DiveRemoteConfig = DiveRemoteConfig;
//# sourceMappingURL=remoteConfig.js.map